import React, {useEffect} from 'react';
import {Outlet, Route, Navigate} from 'react-router-dom';
import {useAuth} from 'store/auth';
import {ToastContainer} from 'react-toastify';
import Navbar from 'components/navbar/Navbar';
import DarkMode from 'components/DarkMode';
import {Gallery} from '../components/Gallery'
import SideBar from "components/navbar/SideBar"

export default function Admin() {

   const {getToken, getMe, dispatch, sidebar, toggleSideBar, getSideBar} = useAuth();
   useEffect(() => {
      if (getToken()) {
         dispatch(getMe())
      }
      if (getSideBar() == 'true') {
         dispatch(toggleSideBar())
      }
   }, [])

   if (!getToken()) {
      return <Navigate to="/auth"/>
   }
   return (
      <>
         <ToastContainer
            position="bottom-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl
            pauseOnFocusLoss
            draggable
            pauseOnHover
         />
         <Gallery/>
         <div className="main overflow-x-hidden md:overflow-x-clip">
            <Navbar/>
            <div className="flex">
               {sidebar && <SideBar/>}
               <Outlet/>
            </div>
            {/*<DarkMode/>*/}
         </div>
      </>
   );
}
